import { SHADOW_BACKGROUND_LEVEL_2_DARK, SHADOW_BACKGROUND_LEVEL_3_DARK, SHADOW_BACKGROUND_CARD_DARK, } from "@audi/audi-ui-design-tokens";
export const shadow = {
    background: {
        level: {
            2: SHADOW_BACKGROUND_LEVEL_2_DARK,
            3: SHADOW_BACKGROUND_LEVEL_3_DARK,
        },
        card: SHADOW_BACKGROUND_CARD_DARK,
    },
};
//# sourceMappingURL=audi-shadows.mjs.mjs.map